import { Message } from 'src/components/common/form/Message';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import useUiuxStore from 'src/store/useUiuxStore';
import { AgGridReact } from 'ag-grid-react';
import { MouseEvent, useEffect, useRef } from 'react';
import { Content_SYS2020_R01 } from './Content_SYS2020_R01';
import { SYS2020_R01Dto } from './Dto_SYS2020_R01';
import { SearchSection_SYS2020_R01 } from './SearchSection_SYS2020_R01';
import useSYS2020_R01Store from './Store_SYS2020_R01';
import { Table_SYS2020_R01 } from './Table_SYS2020_R01';

export const Container_SYS2020_R01 = () => {
	const { SYS2020_R01List } = useSYS2020_R01Store();
	const { setMessage } = useUiuxStore();
	const gridRef = useRef<AgGridReact<SYS2020_R01Dto> | null>(null);

	const {
		clickable, setClickable,
		handleExcelClick,
		defaultSYS2020_R01Row,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_SYS2020_R01({ gridRef, setMessage });

	useEffect(() => {
		if (SYS2020_R01List.length === 0) {
			handleInsertClick({} as MouseEvent<HTMLButtonElement>);
		}
	}, [SYS2020_R01List, handleInsertClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_SYS2020_R01 onEnterKeyDown={fetchData} />
			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_SYS2020_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultSYS2020_R01Row={defaultSYS2020_R01Row}
						handleInsertClick={handleInsertClick}
					/>
				</div>
			</div>
			<Message />
		</div>
	);
};
